import { QuotesWatchlist } from './types';

export const DEFAULT_QUOTES_WATCHLIST: QuotesWatchlist = [
  {
    symbolKey: 'EURUSD',
    digits: 5,
  },
  {
    symbolKey: 'GBPUSD',
    digits: 5,
  },
  {
    symbolKey: 'USDJPY',
    digits: 3,
  },
  {
    symbolKey: 'USDCAD',
    digits: 5,
  },
];
